import * as tslib_1 from "tslib";
import './ExtendedPeoplePicker.scss';
import { BaseExtendedPicker } from '../BaseExtendedPicker';
var BaseExtendedPeoplePicker = /** @class */ (function (_super) {
    tslib_1.__extends(BaseExtendedPeoplePicker, _super);
    function BaseExtendedPeoplePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseExtendedPeoplePicker;
}(BaseExtendedPicker));
export { BaseExtendedPeoplePicker };
var ExtendedPeoplePicker = /** @class */ (function (_super) {
    tslib_1.__extends(ExtendedPeoplePicker, _super);
    function ExtendedPeoplePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ExtendedPeoplePicker;
}(BaseExtendedPeoplePicker));
export { ExtendedPeoplePicker };
//# sourceMappingURL=ExtendedPeoplePicker.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/ExtendedPicker/PeoplePicker/ExtendedPeoplePicker.js
// module id = 800
// module chunks = 0